import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../api';
import AssetsAddModal from './modals/Assets/AssetsAddModal';
import Pagination from '../Tools/Pagination';

const AssetsTab = () => {
  const [assets, setAssets] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
  id: '',
  assets_name: '',
  total_quantity: '',
  assets_limit: '',
  status: true,
  location_id: '',
  area_id: '',
  asset_category: '',
  asset_type: '', 
});

  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentAssetId, setCurrentAssetId] = useState(null);
  const [filters, setFilters] = useState({
    search: '',
    page: 1,
    limit: 10
  });
  const [totalRecords, setTotalRecords] = useState(0);

  const showAlert = (message, isSuccess = true) => {
    alert(`${isSuccess ? 'Success:' : 'Error:'} ${message}`);
  };

  const fetchAssets = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get('/assets', {
        params: {
          search: filters.search,
          page: filters.page,
          limit: filters.limit
        }
      });
      setAssets(response.data?.data || response.data || []);
      setTotalRecords(response.data?.total || response.data?.length || 0);
    } catch (error) {
      console.error('Error fetching assets:', error);
      showAlert('Failed to fetch assets', false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAssets();
  }, [filters]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'status' ? value === 'true' : value
    }));
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value, page: 1 }));
  };

  const handlePageChange = (newPage) => {
    setFilters(prev => ({ ...prev, page: newPage }));
  };

  const openAddModal = () => {
  setIsEditMode(false);
  setFormData({
    id: '',
    assets_name: '',
    total_quantity: '',
    assets_limit: '',
    status: true,
    location_id: '',
    area_id: '',
    asset_category: '',
    asset_type: '',
  });
  setShowModal(true);
};


  const handleEdit = (asset) => {
    setIsEditMode(true);
    setCurrentAssetId(asset.id);
   setFormData({
  id: asset.id,
  assets_name: asset.assets_name,
  total_quantity: asset.total_quantity,
  assets_limit: asset.assets_limit,
  status: asset.status,
  location_id: asset.location_id,
  area_id: asset.area_id,
  asset_category: asset.asset_category,
  asset_type: asset.asset_type,
});

    setShowModal(true);
  };

  const handleSave = async () => {
  try {
    setIsLoading(true);

    const payload = {
      ...formData,
      asset_type: formData.assets_category === 'Device' ? formData.asset_type : null,
    };

    if (isEditMode) {
      await axiosInstance.put(`/assets/${currentAssetId}`, payload);
      showAlert('Asset updated successfully!');
    } else {
      await axiosInstance.post('/assets', payload);
      showAlert('Asset added successfully!');
    }

    setShowModal(false);
    fetchAssets();
  } catch (error) {
    console.error('Save failed:', error);
    showAlert(
      error.response?.data?.message || `Failed to ${isEditMode ? 'update' : 'add'} asset`,
      false
    );
  } finally {
    setIsLoading(false);
  }
};


  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this asset?')) {
      try {
        setIsLoading(true);
        await axiosInstance.delete(`/assets/${id}`);
        showAlert('Asset deleted successfully!');
        fetchAssets();
      } catch (error) {
        console.error('Delete failed:', error);
        showAlert('Failed to delete asset', false);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="tab-pane active" id="assets" role="tabpanel">
      <div className="filter-search mt-3">
        <h6 className="px-2 mb-0">Filter</h6>
        <div className="filter-panel">
          <form className="row">
            <div className="form-group col-12 p-2">
              <input
                type="text"
                className="form-control"
                name="search"
                value={filters.search}
                onChange={handleFilterChange}
                placeholder="Search"
              />
            </div>
          </form>
          <button
            className="btn m-2 d-flex align-items-center justify-content-center btn-outline-primary waves-effect waves-light"
            onClick={openAddModal}
          >
            <i className="ti ti-circle-plus fs-4 me-2"></i>
            Add Asset
          </button>
        </div>
      </div>

      {isLoading ? (
        <div className="text-center py-4">Loading assets...</div>
      ) : (
        <div className="py-3 px-0">
          <div className="table-responsive rounded-2 ros-table">
            <table className="table text-nowrap customize-table mb-0 align-middle">
              <thead className="text-dark fs-4">
                <tr>
                  <th><h6 className="fw-semibold mb-0">ID</h6></th>
                  <th><h6 className="fw-semibold mb-0">Asset Name</h6></th>
                  <th><h6 className="fw-semibold mb-0">Quantity</h6></th>
                  <th><h6 className="fw-semibold mb-0">Limit</h6></th>
                  <th><h6 className="fw-semibold mb-0">Availability</h6></th>
                  <th><h6 className="fw-semibold mb-0">Location</h6></th>
                  <th><h6 className="fw-semibold mb-0">Areas</h6></th>
                  <th><h6 className="fw-semibold mb-0">Actions</h6></th>
                </tr>
              </thead>
              <tbody>
                {assets.length > 0 ? (
                  assets.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.assets_name}</td>
                      <td>{item.total_quantity}</td>
                      <td>{item.assets_limit}</td>
                      <td>{item.status ? 'Yes' : 'No'}</td>
                       <td><p className="mb-0 fw-normal">{item.location?.location_name || 'Null'} </p> </td>
                      <td><p className="mb-0 fw-normal">  {item.area?.area_name || 'Null'} </p></td>
                      <td>
                        <button className="h4 me-3 border-0 bg-transparent" onClick={() => handleEdit(item)}>
                          <i className="ti ti-edit text-warning"></i>
                        </button>
                        <button className="h4 border-0 bg-transparent" onClick={() => handleDelete(item.id)}>
                          <i className="ti ti-trash text-danger"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-4">No assets found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalRecords > 0 && (
            <Pagination
              total={totalRecords}
              limit={filters.limit}
              page={filters.page}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      )}

      <AssetsAddModal
        show={showModal}
        onClose={() => setShowModal(false)}
        formData={formData}
        onChange={handleInputChange}
        onSave={handleSave}
        isEditMode={isEditMode}
        isLoading={isLoading}
      />
    </div>
  );
};

export default AssetsTab;